var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsTitleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#settings_title_icon_svg__clip0_659_2864)",
    stroke: "#3A3A3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 23.75a4.75 4.75 0 100-9.5 4.75 4.75 0 000 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.717 23.75a2.612 2.612 0 00.522 2.882l.095.095a3.168 3.168 0 11-4.48 4.48l-.096-.095a2.612 2.612 0 00-2.881-.522 2.612 2.612 0 00-1.584 2.39v.27a3.167 3.167 0 01-6.333 0v-.142a2.612 2.612 0 00-1.71-2.391 2.613 2.613 0 00-2.882.522l-.095.095a3.167 3.167 0 01-5.41-2.24 3.167 3.167 0 01.93-2.24l.095-.096a2.612 2.612 0 00.522-2.881 2.612 2.612 0 00-2.39-1.584h-.27a3.167 3.167 0 110-6.333h.143a2.613 2.613 0 002.39-1.71 2.613 2.613 0 00-.522-2.882l-.095-.095a3.166 3.166 0 011.028-5.168 3.167 3.167 0 013.453.687l.095.095a2.613 2.613 0 002.881.523h.127a2.613 2.613 0 001.583-2.39v-.27a3.167 3.167 0 116.334 0v.142a2.612 2.612 0 001.583 2.391 2.613 2.613 0 002.882-.522l.095-.095a3.166 3.166 0 015.168 1.028 3.166 3.166 0 01-.688 3.453l-.095.095a2.614 2.614 0 00-.522 2.881v.127a2.612 2.612 0 002.39 1.583h.27a3.167 3.167 0 110 6.334h-.142a2.612 2.612 0 00-2.391 1.583z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "settings_title_icon_svg__clip0_659_2864"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h38v38H0z"
  })))));
}
export default SvgSettingsTitleIcon;